module.exports = __webpack_public_path__ + "h5/img/group.2ee29678.png";